import { doPost, getRequestHeaders } from "../../Common/utils/https";
import { cloudFunctionsUrl } from "../firebase";

const baseUrl = cloudFunctionsUrl;

interface SaveWebSignupLogRocketSession {
  userId: string;
  sessionId: string;
  sessionUrl: string;
  startTime: number;
  platform?: string;
  token: string;
}

export const saveWebSignupLogRocketSession = async (
  params: SaveWebSignupLogRocketSession,
) => {
  const url = `${baseUrl}logrocket/web-signup/sessions`;
  const headers = await getRequestHeaders();
  return doPost(url, headers, {
    ...params,
  });
};
